<!-- <template>
  <div id="inputCpf">
    <input type="text" class="form-control" id="txt1" v-bind:placeholder="placeholder" @blur.prevent="onblur()" v-bind:disabled="disabled" autocomplete="off" @keydown.enter="onEnter">
    <span v-bind:class="icon"></span>
    <input type="hidden" class="form-control" id="txt2">
  </div>
</template>
<script type="text/javascript">
  export default {
    name: 'input-cnpj',
    props: ['value', 'placeholder', 'icon', 'disabled'],
    data () {
      return {
        currentValue: ''
      }
    },
    mounted () {
      let inputs = this.$el.querySelectorAll('input')
      this.in1 = inputs[0]
      this.in2 = inputs[1]
      if (this.value !== undefined) {
        this.in1.value = this.value
        this.in2.value = this.value
      }
      this.in1.addEventListener('keyup', () => {
        this.in2.value = this.in1.value.replace(/[^0-9]+/g, '')
        this.in1.value = this.in1.value.replace(/[^0-9]+/g, '')
        if (this.in1.value.length > 2) {
          this.in1.value = this.in1.value.substring(0, 2) + '.' + this.in1.value.substring(2)
        }
        if (this.in1.value.length > 6) {
          this.in1.value = this.in1.value.substring(0, 6) + '.' + this.in1.value.substring(6)
        }
        if (this.in1.value.length > 10) {
          this.in1.value = this.in1.value.substring(0, 10) + '/' + this.in1.value.substring(10)
        }
        if (this.in1.value.length > 15) {
          this.in1.value = this.in1.value.substring(0, 15) + '-' + this.in1.value.substring(15)
        }
        if (this.in1.value.length > 18) {
          this.in1.value = this.in1.value.substring(0, 18)
        }
        if (this.in2.value.length > 18) {
          this.$emit('input', this.in2.value.substring(0, 18))
        } else {
          this.$emit('input', this.in2.value)
        }
      })
      this.in1.addEventListener('keydown', (e) => {
        if (this.in1.value.length === 18) {
          if (e.keyCode !== 8 && e.keyCode !== 9) {
            e.preventDefault()
          }
        }
      })
      this.mask(this.value)
    },
    methods: {
      mask (val) {
        if (val !== undefined && val !== null) {
          if (val.length) {
            if (val.length === 14) {
              let pt0 = val.substring(0, 2)
              let pt1 = val.substring(2, 5)
              let pt2 = val.substring(5, 8)
              let pt3 = val.substring(8, 12)
              let pt4 = val.substring(12, 14)
              this.in1.value = `${pt0}.${pt1}.${pt2}/${pt3}-${pt4}`
            }
          } else {
            this.in1.value = ''
            this.in2.value = ''
          }
        } else {
          this.in1.value = ''
          this.in2.value = ''
        }
      },
      onblur () {
        if (this.in1.value.length === 18) {
          this.$emit('input-blur')
        }
      },

      onEnter () {
        this.$emit('on-enter')
      }
    },
    computed: {
      valueUnmasked () {
        return this.currentValue.replace(/[^0-9]+/g, '')
      }
    },
    watch: {
      value: function (val) {
        this.mask(val)
      }
    }
  }
</script> -->
<template>
  <div>
    <input
      id="__ncm_input_cnpj"
      type="text"
      class="form-control"
      v-bind:placeholder="placeholder"
      v-bind:disabled="disabled"
      autocomplete="off"
      @keydown.enter="onEnter"
      @keydown="onKeyDown"
      @keyup="onKeyUp"
      @blur="onBlur"
      :value="currentValue"
    />
    <span v-bind:class="icon"></span>
  </div>
</template>
<script type="text/javascript">
export default {
  props: ['value', 'placeholder', 'icon', 'disabled'],
  data() {
    return {
      currentValue: ''
    }
  },
  mounted() {},
  methods: {
    onBlur() {
      this.$emit('on-blur')
    },

    mask(value) {
      this.currentValue = value.replace(/[^0-9]+/g, '')
      if (this.currentValue.length > 2) {
        this.currentValue = this.currentValue.substring(0, 2) + '.' + this.currentValue.substring(2)
      }
      if (this.currentValue.length > 6) {
        this.currentValue = this.currentValue.substring(0, 6) + '.' + this.currentValue.substring(6)
      }
      if (this.currentValue.length > 10) {
        this.currentValue =
          this.currentValue.substring(0, 10) + '/' + this.currentValue.substring(10)
      }
      if (this.currentValue.length > 15) {
        this.currentValue =
          this.currentValue.substring(0, 15) + '-' + this.currentValue.substring(15)
      }
      if (this.currentValue.length > 18) {
        this.currentValue = this.currentValue.substring(0, 18)
      }
      if (this.currentValue.length === 0) {
        this.currentValue = null
      }
      this.$emit('input', this.valueUnmasked)
    },
    onKeyUp(event) {
      this.mask(event.target.value)
    },
    onKeyDown(e) {
      if (e.target.value.length === 18) {
        if (e.keyCode !== 8 && e.keyCode !== 9) {
          e.preventDefault()
        }
      }
    },
    onEnter() {
      this.$emit('on-enter')
    }
  },
  computed: {
    valueUnmasked() {
      return this.currentValue ? this.currentValue.replace(/[^0-9]+/g, '') : null
    }
  },
  watch: {
    value(vl) {
      if (vl) {
        this.currentValue = vl
        this.mask(vl)
      }
    }
  }
}
</script>
